module.exports = __webpack_public_path__ + "5ff172ecfbbadfe931b89ee709df68fa.svg";